<template>
	<el-dialog class="dialog" title="查看" :visible.sync="visiable">
		<div class="dlalog-body">
			<el-form ref="form" :model="formData" label-width="120px">
				<el-row>
					<el-col :span="12">
						<el-form-item label="用户账号：">
							<el-input v-model="formData.accountNo" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="账号类型：">
							<el-input v-model="formData.isMaster==1?'主账号':'子账号'" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="经办人：">
							<el-input v-model="formData.agentName" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="经办人身份证：">
							<el-input v-model="formData.agentIdCard" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="经办人手机：">
							<el-input v-model="formData.agentMobile" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="账号权限：">
							<el-input v-model="roles" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="企业名称：">
							<el-input v-model="formData.entName" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="信用代码：">
							<el-input v-model="formData.creditCode" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="法人姓名：">
							<el-input v-model="formData.legalPersonName" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="法人身份证：">
							<el-input v-model="formData.legalPersonIdCard" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="所在城市：">
							<el-input v-model="formData.city" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="详细地址：">
							<el-input v-model="formData.address" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="images">
					<el-image :src="imgUrl[0]" fit="fill"></el-image>
					<el-image :src="imgUrl[1]" fit="fill"></el-image>
					<el-image :src="imgUrl[2]" fit="fill"></el-image>
					<el-image :src="imgUrl[3]" fit="fill"></el-image>
					<el-image :src="imgUrl[4]" fit="fill"></el-image>
					<el-image :src="imgUrl[5]" fit="fill"></el-image>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="账号状态：" v-if="dialogObj.type!=0">
							<el-input v-model="formData.status==1?'启用中':'已禁用'" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="close()">关闭</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
	import {
		dialogMixin
	} from "@m/dialogMixin"
	import configApi from '@config/configApi'
	export default {
		mixins: [dialogMixin],
		data() {
			return {
				formData: {},
				imgUrl: [],
				roles: ""
			};
		},
		props: {},
		watch: {},
		methods: {
			//打开弹窗
			open() {
				this.formData = {};
				this.imgUrl = [];
				this.roles = "";
				this.get();
			},
			//获取数据
			get() {
				this.$get("/user-api/qs/user/" + this.dialogObj.id, null).then((res) => {
					if (res.code == 1000) {
						this.formData = res.data;
						this.imgUrl.push(configApi.photoURL + this.formData.businessLicenseImg);
						this.imgUrl.push(configApi.photoURL + this.formData.legalPersonIdCardPosImg);
						this.imgUrl.push(configApi.photoURL + this.formData.legalPersonIdCardNegImg);
						this.imgUrl.push(configApi.photoURL + this.formData.entAuthLetterImg);
						this.imgUrl.push(configApi.photoURL + this.formData.agentIdCardPosImg);
						this.imgUrl.push(configApi.photoURL + this.formData.agentIdCardNegImg);
						for (let i in this.formData.roles) {
							var item = this.formData.roles[i];
							this.roles += item.name;
							if (i < this.formData.roles.length - 1) {
								this.roles += ",";
							}
						}
					} else {
						this.$message.error(res.msg);
					}
				});
			},
			//关闭弹窗
			close() {
				this.visiable = false
			}
		}
	};
</script>
<style lang='scss' scoped>
	.dialog {
		::v-deep.cascader {
			display: block;
		}

		::v-deep.el-image {
			width: 80px;
			height: 80px;
			margin-right: 20px;
		}

		.images {
			margin: 10px 25px;
		}
	}
</style>
